<template>
  <el-dialog title="填写快递单号" :visible.sync="visible" width="560px" center append-to-body :before-close="handleCloseDialog">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="物流公司">
        <el-select class="w368px" v-model="form.deliveryCorpId" placeholder="请选择物流公司">
          <el-option v-for="item in shipCorps" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号">
        <el-input class="w368px" v-model="form.trackingNo" placeholder="请输入物流单号"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="red-line" @click="handleCloseDialog">取 消</el-button>
      <el-button class="red-block" @click="handleTransitTabs">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Undo',
  props: ['visible', 'shipCorps'],
  data () {
    return {
      form: {
        deliveryCorpId: null,
        trackingNo: null
      }
    }
  },
  methods: {
    handleCloseDialog () {
      this.$emit('handleCloseDialog')
    },
    handleTransitTabs () {
      this.$emit('handleTransitTabs', this.form)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/common/css/dialog.scss';
</style>
